import ServiceExec from '@/common/utils/ServiceExec';
import BannerApi from '@/common/service/apis/BannerApi';

class BannerSvc extends ServiceExec {
  getBannerList(params = {}) {
    return this.get(BannerApi.getBannerList, {}).then(response => response.data);
  }

  getPopupList(params = {}) {
    return this.get(BannerApi.getPopupList, params).then(response => response.data);
  }
}

export default new BannerSvc();
